/* ============================================================
   WESTSIDE BARBELL — BLOG JS
   1. Predictive article search (Shopify Predictive Search API)
   2. Imported-content cleanup (legacy Word/old-site HTML)
   3. Auto table of contents from article H2s + nested H3s
   4. FAQ accordion + schema; progress ring; snippets; copy link
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Predictive article search ---------- */
  var searchInput = document.querySelector('[data-wsbb-search-input]');
  var searchResults = document.querySelector('[data-wsbb-search-results]');
  var debounceTimer;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (!q.length) { searchResults.hidden = true; return; }
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-wsbb-search]')) searchResults.hidden = true;
    });

    function fetchSuggestions(q) {
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root : '/';
      url += 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=article&resources[limit]=6&resources[options][fields]=title,body';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (searchInput.value.trim() !== q) return; // stale response — query changed
          var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
          searchResults.innerHTML = '';
          if (!articles.length) {
            searchResults.innerHTML = '<div class="wsbb-search__empty">No articles found</div>';
          } else {
            articles.forEach(function (a) {
              var link = document.createElement('a');
              link.href = a.url;
              link.textContent = a.title;
              searchResults.appendChild(link);
            });
            // Every match, on the search page's Articles tab (as pressing Enter does).
            var all = document.createElement('a');
            all.className = 'wsbb-search__all';
            all.href = searchInput.form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&tab=articles';
            all.textContent = 'See all results for \u201c' + q + '\u201d';
            searchResults.appendChild(all);
          }
          searchResults.hidden = false;
        })
        .catch(function () { searchResults.hidden = true; });
    }
  }

  var content = document.querySelector('[data-wsbb-content]');

  /* ---------- 2. Imported-content cleanup ----------
     Legacy posts (Word / old-site HTML) ship tables padded with empty
     spacer rows and columns — they render as broken ghost cells. Drop
     any row or column that is empty across the whole table, then wrap
     tables for horizontal scroll on narrow screens. Word layout divs
     (page/layoutArea/column) are unwrapped via CSS display:contents. */
  if (content) {
    content.querySelectorAll('table').forEach(function (tbl) {
      var cellEmpty = function (c) { return !c.textContent.trim() && !c.querySelector('img,iframe'); };
      var rows = Array.prototype.slice.call(tbl.rows);
      rows.forEach(function (r) {
        if (Array.prototype.every.call(r.cells, cellEmpty)) r.remove();
      });
      rows = Array.prototype.slice.call(tbl.rows);
      if (!rows.length) { tbl.remove(); return; }
      // Column removal is only safe when no cell spans rows/columns
      var usesSpans = rows.some(function (r) {
        return Array.prototype.some.call(r.cells, function (c) { return c.colSpan > 1 || c.rowSpan > 1; });
      });
      if (!usesSpans) {
        var maxCols = 0;
        rows.forEach(function (r) { maxCols = Math.max(maxCols, r.cells.length); });
        for (var col = maxCols - 1; col >= 0; col--) {
          var allEmpty = rows.every(function (r) { return !r.cells[col] || cellEmpty(r.cells[col]); });
          if (allEmpty) {
            rows.forEach(function (r) { if (r.cells[col]) r.cells[col].remove(); });
          }
        }
      }
      if (!tbl.parentElement.classList.contains('wsbb-table-scroll')) {
        var wrap = document.createElement('div');
        wrap.className = 'wsbb-table-scroll';
        tbl.before(wrap);
        wrap.appendChild(tbl);
      }
    });
  }

  /* ---------- 3. Auto table of contents ----------
     H2s = numbered entries; H3s nest under their parent H2 with letter
     labels. Skipped: empty headings (imported posts have blank h2s),
     pull-quote headings inside blockquotes, and H3s in a FAQ section
     (those become accordions in step 4). */
  var toc = document.querySelector('[data-wsbb-toc]');
  var tocList = document.querySelector('[data-wsbb-toc-list]');
  var faqRe = /^(faqs?|frequently asked)/i;

  if (toc && tocList && content) {
    var currentH2Li = null;
    var currentSub = null;
    var inFaq = false;
    var h2Count = 0;
    var idSeq = 0;
    content.querySelectorAll('h2, h3').forEach(function (h) {
      var text = h.textContent.trim();
      if (!text || h.closest('blockquote')) return;
      idSeq++;
      if (!h.id) {
        h.id = 'section-' + idSeq + '-' + text.toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').slice(0, 60);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      if (h.tagName === 'H2') {
        inFaq = faqRe.test(text);
        tocList.appendChild(li);
        currentH2Li = li;
        currentSub = null;
        h2Count++;
      } else {
        if (inFaq || !currentH2Li) return;
        if (!currentSub) {
          currentSub = document.createElement('ol');
          currentH2Li.appendChild(currentSub);
        }
        currentSub.appendChild(li);
      }
    });
    if (h2Count >= 2) {
      toc.hidden = false;
    } else {
      tocList.innerHTML = '';
    }
  }

  /* ---------- 4. FAQ accordion + FAQPage schema ----------
     Convention: an H2 whose text starts with "FAQ" or "Frequently Asked"
     marks the FAQ section. Each following H3 = question; the nodes until
     the next H3/H2 = answer. Converts to <details> accordions and injects
     FAQPage JSON-LD. Writers author plain H3s + paragraphs — no shortcode. */
  if (content) {
    var faqHead = Array.prototype.find.call(content.querySelectorAll('h2'), function (h) {
      // Skip DropInBlog placeholder wrappers and headings with nothing after them
      return faqRe.test(h.textContent.trim()) &&
        !h.closest('.dib-faq') && h.nextElementSibling;
    });
    if (faqHead) {
      var faqData = [];
      var node = faqHead.nextElementSibling;
      while (node && !(node.tagName === 'H2')) {
        if (node.tagName === 'H3') {
          var q = node.textContent.trim();
          var details = document.createElement('details');
          details.className = 'wsbb-faq-item';
          var summary = document.createElement('summary');
          summary.textContent = q;
          details.appendChild(summary);
          var answerWrap = document.createElement('div');
          answerWrap.className = 'wsbb-faq-item__a';
          var next = node.nextElementSibling;
          var answerText = [];
          while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
            var moved = next;
            next = next.nextElementSibling;
            answerWrap.appendChild(moved);
            answerText.push(moved.textContent.trim());
          }
          details.appendChild(answerWrap);
          node.replaceWith(details);
          node = next;
          faqData.push({ q: q, a: answerText.join(' ') });
        } else {
          node = node.nextElementSibling;
        }
      }
      if (faqData.length) {
        var ld = {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          'mainEntity': faqData.map(function (f) {
            return {
              '@type': 'Question',
              'name': f.q,
              'acceptedAnswer': { '@type': 'Answer', 'text': f.a }
            };
          })
        };
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(ld);
        document.head.appendChild(script);
      }
    }
  }

  /* ---------- 5. Reading progress circle ----------
     Circular indicator (DropInBlog-style) showing article scroll progress.
     Markup: <div class="wsbb-progress"><span data-wsbb-progress></span></div>
     Rendered as an SVG ring, fixed bottom-right; click = back to top. */
  var progressHost = document.querySelector('.wsbb-progress');
  if (progressHost && content) {
    progressHost.innerHTML =
      '<svg viewBox="0 0 44 44" width="44" height="44" role="img" aria-label="Reading progress">' +
      '<circle class="wsbb-progress__track" cx="22" cy="22" r="18"/>' +
      '<circle class="wsbb-progress__fill" cx="22" cy="22" r="18" data-wsbb-progress-ring/>' +
      '</svg><span class="wsbb-progress__pct" data-wsbb-progress-pct></span>';
    var ring = progressHost.querySelector('[data-wsbb-progress-ring]');
    var pctEl = progressHost.querySelector('[data-wsbb-progress-pct]');
    var C = 2 * Math.PI * 18;
    ring.style.strokeDasharray = C;
    ring.style.strokeDashoffset = C;
    var ticking = false;
    function updateProgress() {
      var rect = content.getBoundingClientRect();
      var winH = window.innerHeight;
      var total = rect.height - winH;
      var done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      var pct;
      if (total > 0) {
        pct = done / total;
      } else {
        // Article shorter than viewport: base progress on how much has entered view
        pct = rect.bottom <= winH ? 1 : Math.min(Math.max((winH - rect.top) / rect.height, 0), 1);
      }
      pct = Math.min(Math.max(pct, 0), 1);
      ring.style.strokeDashoffset = C * (1 - pct);
      pctEl.textContent = Math.round(pct * 100) + '%';
      progressHost.classList.toggle('is-visible', rect.top < winH * 0.5);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(updateProgress); }
    }, { passive: true });
    progressHost.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    updateProgress();
  }

  /* ---------- 6. Mid-content smart snippets ----------
     Snippets rendered with data-wsbb-inject-after-p="N" are moved into the
     article after the Nth top-level paragraph, then unhidden. */
  if (content) {
    document.querySelectorAll('[data-wsbb-inject-after-p]').forEach(function (snip) {
      var n = parseInt(snip.getAttribute('data-wsbb-inject-after-p'), 10) || 1;
      // Imported posts often wrap paragraphs in nested divs — use all
      // descendant paragraphs, excluding accordions/TOC internals.
      var paras = Array.prototype.filter.call(content.querySelectorAll('p'), function (par) {
        return !par.closest('details');
      });
      if (!paras.length) { snip.remove(); return; }
      var anchor = paras[Math.min(n, paras.length) - 1];
      anchor.after(snip);
      snip.hidden = false;
    });
  }

  /* ---------- 7. Copy link ---------- */
  var copyBtn = document.querySelector('[data-wsbb-copylink]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(copyBtn.dataset.url).then(function () {
        var prev = copyBtn.textContent;
        copyBtn.textContent = '✓';
        setTimeout(function () { copyBtn.textContent = prev; }, 1500);
      });
    });
  }
})();

  /* ---------- Klaviyo signup fallback ----------
     The Klaviyo embed is injected by Klaviyo's own app block. If it is absent
     (a store without the app) or slow/blocked, the slot stays empty — so after
     a short grace period, reveal the native customer form instead of leaving a
     blank panel where the signup should be. */
  (function () {
    var slots = document.querySelectorAll('[data-wsbb-klaviyo]');
    if (!slots.length) return;
    setTimeout(function () {
      Array.prototype.forEach.call(slots, function (slot) {
        if (slot.children.length) return;                 // Klaviyo rendered
        var wrap = slot.parentNode;
        if (!wrap) return;
        var fb = wrap.querySelector('[data-wsbb-signup-fallback]');
        if (fb) { fb.hidden = false; slot.remove(); }
      });
    }, 2500);
  })();

  /* ---------- Collapsible author bio ----------
     The bio ships expanded so it reads in full without JS. Clamp it here and
     show the toggle, but only when it actually overflows three lines — a
     one-line bio with a "Read more" under it is just noise. */
  (function () {
    var bios = document.querySelectorAll('[data-wsbb-bio]');
    if (!bios.length) return;

    // Measure after webfonts land — the clamp is a line count, and the
    // fallback face wraps differently enough to misjudge a borderline bio.
    var ready = document.fonts && document.fonts.ready
      ? document.fonts.ready
      : { then: function (f) { f(); } };

    ready.then(function () { Array.prototype.forEach.call(bios, setup); });

    function setup(bio) {
      var text = bio.querySelector('.wsbb-bio__text');
      var btn = bio.querySelector('.wsbb-bio__toggle');
      if (!text || !btn) return;

      bio.classList.add('wsbb-bio--collapsed');
      if (text.scrollHeight <= text.clientHeight + 1) {
        bio.classList.remove('wsbb-bio--collapsed');   // fits; leave it open
        return;
      }

      bio.classList.add('wsbb-bio--enhanced');
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var open = bio.classList.toggle('wsbb-bio--collapsed') === false;
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();

  /* ---------- Blog grid: "Sort by" (Newest / Recently updated / Oldest first) ----------
     Newest is the server's own order. "Recently updated" (?sort=updated) is
     re-sorted in the browser, because nothing in Shopify sorts articles by a
     metafield and Liquid sees one page of a blog at a time. Sort key: the
     editor-set Updated At metafield when later than the publish date, else
     the publish date.

     Speed. Measured, each feed page is ~0.7s of Shopify rendering 250
     articles and a card is ~0.5s. So:
     - all feed pages are fetched at once (the server says how many);
     - keys are kept in localStorage for 30 min, versioned by article count so
       a new post invalidates them;
     - keys start loading when the reader opens the dropdown, before they pick;
     - on page 1 the sort switches in place (no reload); cards are reused and
       only ones pulled in from other pages are fetched (?view=card).
     While it works, the cards show as placeholders (.is-sorting); on a
     direct ?sort=updated load an inline script in main-blog sets that before
     first paint. Any failure falls back to the server's order. */
  (function () {
    var grid = document.querySelector('[data-wsbb-sort]');
    var select = document.querySelector('[data-wsbb-blog-sort]');
    if (!grid || !select) return;

    var page = parseInt(grid.getAttribute('data-page'), 10) || 1;
    var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 12;
    var keysUrl = grid.getAttribute('data-keys-url');
    var keysPages = parseInt(grid.getAttribute('data-keys-pages'), 10) || 1;
    var version = grid.getAttribute('data-keys-version') || '';
    var showExcerpt = grid.getAttribute('data-show-excerpt') === 'true';
    var cacheKey = 'wsbb-sortkeys:' + keysUrl;
    var cacheTtl = 30 * 60 * 1000;

    var heading = document.querySelector('[data-wsbb-sort-heading]');
    var headingNewest = heading ? (heading.getAttribute('data-heading') || heading.textContent) : '';
    var links = Array.prototype.slice.call(document.querySelectorAll('.wsbb-pagination a[href]'));
    links.forEach(function (a) { a.setAttribute('data-href', a.getAttribute('href')); });

    // The page as the server rendered it: publish order for this page.
    var slots = Array.prototype.slice.call(grid.querySelectorAll('.wsbb-card[data-handle]'));
    var newestOrder = slots.map(function (s) { return s.getAttribute('data-handle'); });
    var byHandle = {};
    slots.forEach(function (s) { byHandle[s.getAttribute('data-handle')] = s; });

    // The orders and their grid headings ('' keeps the section's own heading).
    // Newest is the server's order; the others are sorted here. The section's
    // "Default sort" is what a bare URL shows; any other order is in ?sort=.
    var SORTS = { newest: '', updated: 'Recently updated', oldest: 'Oldest first' };
    function known(v) { return SORTS.hasOwnProperty(v) ? v : ''; }
    var defaultSort = known(grid.getAttribute('data-default-sort')) || 'newest';
    var wanted = known(new URLSearchParams(location.search).get('sort')) || defaultSort;
    var current = 'newest';   // the order on screen: the server renders newest first
    select.value = wanted;

    function loading(on) { grid.classList.toggle('is-sorting', on); grid.setAttribute('aria-busy', on ? 'true' : 'false'); }

    /* --- keys --- */
    var keysPromise = null;
    function readCache() {
      try {
        var c = JSON.parse(localStorage.getItem(cacheKey));
        if (c && c.v === version && Date.now() - c.t < cacheTtl) return c.items;
      } catch (e) {}
      return null;
    }
    function loadKeys() {
      if (keysPromise) return keysPromise;
      var cached = readCache();
      if (cached) return (keysPromise = Promise.resolve(cached));
      var reqs = [];
      for (var n = 1; n <= keysPages; n++) {
        reqs.push(fetch(keysUrl + '?view=sortkeys&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }));
      }
      keysPromise = Promise.all(reqs).then(function (pages) {
        var items = [];
        pages.forEach(function (p) { items = items.concat(p.items); });
        try { localStorage.setItem(cacheKey, JSON.stringify({ v: version, t: Date.now(), items: items })); } catch (e) {}
        return items;
      });
      keysPromise.catch(function () { keysPromise = null; });  // allow a retry
      return keysPromise;
    }
    // Warm the keys as soon as the reader shows interest in the dropdown.
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
      select.addEventListener(ev, function () { loadKeys().catch(function () {}); }, { once: true, passive: true });
    });

    /* --- cards --- */
    function fetchCard(handle) {
      return fetch('/blogs/' + handle + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var t = document.createElement('template');
          t.innerHTML = html.trim();
          var card = t.content.querySelector('.wsbb-card');
          if (!card) throw new Error('no card for ' + handle);
          if (!showExcerpt) { var ex = card.querySelector('.wsbb-card__excerpt'); if (ex) ex.remove(); }
          return card;
        });
    }

    // Put these handles into the card slots, in order. Ad cards keep theirs.
    function apply(want) {
      var have = Array.prototype.slice.call(grid.querySelectorAll('.wsbb-card[data-handle]'));
      if (want.join('\n') === have.map(function (s) { return s.getAttribute('data-handle'); }).join('\n')) return Promise.resolve();
      var missing = want.filter(function (h) { return !byHandle[h]; });
      return Promise.all(missing.map(fetchCard)).then(function (cards) {
        cards.forEach(function (c, i) { byHandle[missing[i]] = c; });
        // Mark every slot first, then swap, so moving a card that already sits
        // in a later slot can't disturb the positions still to be filled.
        var marks = have.map(function (s) {
          var m = document.createComment('wsbb-slot');
          s.parentNode.insertBefore(m, s);
          return m;
        });
        have.forEach(function (s) { s.remove(); });
        marks.forEach(function (m, i) {
          if (want[i]) m.parentNode.replaceChild(byHandle[want[i]], m);
          else m.remove();
        });
        document.dispatchEvent(new CustomEvent('wsbb:cards-updated'));
      });
    }

    // This page's handles in a browser-sorted order. The keys come in the
    // blog's own order, newest first, so Oldest first is that list reversed.
    function sortedOrder(sortBy) {
      return loadKeys().then(function (items) {
        var order = items.map(function (it, i) { return { h: it[0], k: it[1], i: i }; });
        if (sortBy === 'oldest') {
          order.reverse();
        } else {
          // Recently updated. Stable: newest key first, publish order breaks ties.
          order.sort(function (a, b) { return a.k !== b.k ? (a.k < b.k ? 1 : -1) : a.i - b.i; });
        }
        return order.slice((page - 1) * perPage, page * perPage).map(function (o) { return o.h; });
      });
    }

    /* --- chrome: heading, page links, URL --- */
    function reflect(sortBy) {
      if (heading) heading.textContent = SORTS[sortBy] || headingNewest;
      var inUrl = sortBy !== defaultSort;
      links.forEach(function (a) {
        var u = new URL(a.getAttribute('data-href'), location.origin);
        if (inUrl) u.searchParams.set('sort', sortBy); else u.searchParams.delete('sort');
        a.setAttribute('href', u.pathname + u.search);
      });
      // Only when it changes, and never in the theme editor, which treats a URL
      // rewrite in its preview as a redirect.
      var url = new URL(location.href);
      if (inUrl) url.searchParams.set('sort', sortBy); else url.searchParams.delete('sort');
      var next = url.pathname + url.search + url.hash;
      if (!(window.Shopify && window.Shopify.designMode) && next !== location.pathname + location.search + location.hash) {
        history.replaceState(history.state, '', next);
      }
    }

    function show(sortBy) {
      loading(true);
      var order = sortBy === 'newest' ? Promise.resolve(newestOrder) : sortedOrder(sortBy);
      return order.then(apply).then(function () {
        current = sortBy;
        reflect(sortBy);
      }).catch(function () {
        select.value = current;           // couldn't sort: stay as we were
        if (heading) heading.textContent = SORTS[current] || headingNewest;
      }).then(function () { loading(false); });
    }

    select.addEventListener('change', function () {
      var sortBy = known(select.value) || defaultSort;
      if (page === 1) { show(sortBy); return; }
      // Mid-listing, a new order starts again from its page 1.
      var url = new URL(location.href);
      url.searchParams.delete('page');
      if (sortBy !== defaultSort) url.searchParams.set('sort', sortBy); else url.searchParams.delete('sort');
      location.href = url.pathname + url.search;
    });

    if (wanted !== 'newest') {
      if (!window.fetch || !slots.length) { loading(false); select.value = current; return; }
      show(wanted);
    }
  })();

  /* ---------- Anchor offset ----------
     The site header is sticky, so a bare #hash jump (the table of contents,
     FAQ links) parked the heading underneath it. Publish the header's height
     for scroll-margin-top (wsbb-blog.css). It's the header bar itself: after
     any jump the page is scrolled, and the nav row below the bar has scrolled
     away. Re-measured when the header changes size. Ported from the demo
     theme (docs/demo-theme-changes.md). */
  (function () {
    var siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;
    function measure() {
      document.documentElement.style.setProperty('--wsbb-anchor-offset', (siteHeader.offsetHeight + 20) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    document.addEventListener('headerStickyChange', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(siteHeader);

    // Arriving on a #hash link: the browser jumped before the offset existed,
    // and images loading above the target can move it after. Settle on the
    // target once now and once when the page has loaded, unless the reader
    // has started scrolling themselves.
    var target = null;
    try { target = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
    if (!target) return;
    var touched = false;
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, function () { touched = true; }, { once: true, passive: true });
    });
    function settle() { if (!touched) target.scrollIntoView({ block: 'start' }); }
    requestAnimationFrame(settle);
    if (document.readyState === 'complete') setTimeout(settle, 0);
    else window.addEventListener('load', settle, { once: true });
  })();

  /* ---------- Tag separators on wrapped lines ----------
     Tags are separated by a pipe drawn at the start of each tag. When a list
     wraps, the first tag on the new line would carry a pipe with nothing
     before it, indenting the line. Mark the first tag of each line so CSS can
     drop it. Each list is measured with every pipe present, then marked, so
     the result doesn't depend on the previous pass.

     Driven by a ResizeObserver on each list rather than page events: a list
     inside something hidden (the search page's inactive tabs) measures as
     zero, and gets marked the moment it's shown, as well as on any resize.
     Lists added later are picked up on wsbb:cards-updated.

     Byline rows (.wsbb-meta: author · date · read time) get the same care: a
     "·" between two items that land on different lines is hidden. It's hidden
     in place (visibility, not display) so nothing reflows and a measurement
     can't flip the result back. */
  (function () {
    function markMeta(row) {
      if (!row.offsetParent) return;
      var dots = row.querySelectorAll('.wsbb-meta__dot');
      dots.forEach(function (d) { d.classList.remove('is-break'); });
      dots.forEach(function (d) {
        var prev = d.previousElementSibling;
        var next = d.nextElementSibling;
        if (prev && next && next.offsetTop > prev.offsetTop + 2) d.classList.add('is-break');
      });
    }

    function markList(list) {
      if (list.classList.contains('wsbb-meta')) { markMeta(list); return; }
      if (!list.offsetParent) return;           // hidden: wait until it's shown
      var tags = list.querySelectorAll('.wsbb-tag');
      tags.forEach(function (t) { t.classList.remove('is-row-start'); });
      var starts = [];
      var lastTop = null;
      tags.forEach(function (t) {
        var top = t.offsetTop;
        if (lastTop !== null && top > lastTop + 2) starts.push(t);
        lastTop = top;
      });
      starts.forEach(function (t) { t.classList.add('is-row-start'); });
    }

    var LISTS = '.wsbb-tags, .wsbb-meta';
    function markAll() { document.querySelectorAll(LISTS).forEach(markList); }

    if (!('ResizeObserver' in window)) {
      markAll();
      window.addEventListener('resize', markAll);
      document.addEventListener('wsbb:cards-updated', markAll);
      return;
    }

    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) { markList(e.target); });
    });
    function observeNew() {
      document.querySelectorAll('.wsbb-tags:not([data-tags-observed]), .wsbb-meta:not([data-tags-observed])').forEach(function (list) {
        list.setAttribute('data-tags-observed', '');
        ro.observe(list);                       // fires once now, then on every resize
      });
    }

    observeNew();
    document.addEventListener('wsbb:cards-updated', observeNew);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markAll);
  })();
